import React, { Component } from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import moment from 'moment';

import { getContent, getErrorMessage } from '../../../util/responseUtil';
import { ROUTER_CONSTANT } from '../../../constants/routerConstant';
import API_MASTER_DATA from '../../../api/apiMasterData';
import API_SEARCH from '../../../api/apiSearch';
import IconDeleteBlue from '../../../assets/icons/IconDeleteBlue';
import IconDetailBlue from '../../../assets/icons/IconDetailBlue';
import IconEditBlue from '../../../assets/icons/IconEditBlue';
import IconAddBlue from '../../../assets/icons/IconAddBlue';
import SearchbarMenu from '../../../components/Searchbar/SearchbarMenu';
import ActionType from '../../../redux/reducer/globalActionType';
import { CheckPermissionComponent } from '../../../util/permission';
import {
    MASTER_DATA_DATA_GROUP_DELETE,
    MASTER_DATA_DATA_GROUP_INSERT,
    MASTER_DATA_DATA_GROUP_UPDATE,
    MASTER_DATA_DATA_GROUP_VIEW
} from '../../../constants/menuPermissionConstant';
import Alert from '../../../components/Alert/Alert';
import TableNexcare from '../../../components/Table/TableNexcare';
import LoadingLoader from '../../../components/LoadingLoader/LoadingLoader';

class DataGroup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            columnsDataGroup: [
                {
                    title: "ID Data Group",
                    dataIndex: "group_id",
                    headerAlign: "justify-start",
                    bodyAlign: "text-left",
                    render: (data) => `${data}`,
                },
                {
                    title: "Deskripsi Data Group",
                    dataIndex: "description",
                    headerAlign: "justify-start",
                    bodyAlign: "text-left",
                    render: (data) => `${data}`,
                },
                {
                    title: "Waktu Dibuat",
                    dataIndex: "created_at",
                    headerAlign: "justify-start",
                    bodyAlign: "text-left",
                    render: (data) => `${data === "" ? "-" : moment.utc(data).format('DD/MM/YYYY HH:mm')}`,
                },
                {
                    title: "Waktu Diubah",
                    dataIndex: "updated_at",
                    headerAlign: "justify-start",
                    bodyAlign: "text-left",
                    render: (data) => `${data === "" ? "-" : moment.utc(data).format('DD/MM/YYYY HH:mm')}`,
                },
                {
                    title: "Diubah Oleh",
                    dataIndex: "modified_by",
                    headerAlign: "justify-start",
                    bodyAlign: "text-left",
                    render: (data) => `${data}`,
                },
                {
                    title: "Aksi",
                    headerAlign: "justify-start",
                    bodyAlign: "text-left",
                    render: (data) => (
                        <div className="flex">
                            <CheckPermissionComponent permissionConstant={[MASTER_DATA_DATA_GROUP_VIEW]} userPermission={this.props.userDetail.permissions}>
                                <span className="cursor-pointer mr-5" id="btndetaildatagroup" onClick={() => this.handleDetailDataGroup(data)}><IconDetailBlue /></span>
                            </CheckPermissionComponent>
                            <CheckPermissionComponent permissionConstant={[MASTER_DATA_DATA_GROUP_UPDATE]} userPermission={this.props.userDetail.permissions}>
                                <span className="cursor-pointer mr-5" id="btneditdatagroup" onClick={() => this.handleEditDataGroup(data)}><IconEditBlue /></span>
                            </CheckPermissionComponent>
                            <CheckPermissionComponent permissionConstant={[MASTER_DATA_DATA_GROUP_DELETE]} userPermission={this.props.userDetail.permissions}>
                                <span className="cursor-pointer" id="btndeletedatagroup" onClick={() => this.handleConfirmDeleteDataGroup(data)}><IconDeleteBlue /></span>
                            </CheckPermissionComponent>
                        </div>
                    ),
                },
            ],
            pagination: {
                current: 1,
                pageSize: 10,
                total: 0,
            },
            data: [],
            keyword: '',
            dataGroup: {},
            showSuccessAlert: false,
            showConfirmAlert: false,
            showErrorAlertResponse: false,
            errorMessage: ''
        }
    }

    getInitiateDataGroup = () => {
        API_MASTER_DATA.getInitiateDataGroup(this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        pagination: {
                            ...this.state.pagination,
                            total: getContent(res).count_data
                        }
                    })
                }
            }).catch(err => {
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    getListDataGroup = () => {
        API_MASTER_DATA.getListDataGroup(this.state.pagination.current, this.state.pagination.pageSize, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        loading: false,
                        data: getContent(res)
                    })
                }
            }).catch(err => {
                this.setState({ loading: false });
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    getInitiateSearchDataGroup = keyword => {
        API_SEARCH.getInitiateDataGroup(keyword, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        pagination: {
                            ...this.state.pagination,
                            total: getContent(res).count_data
                        }
                    })
                }
            }).catch(err => {
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    getSearchDataGroup = keyword => {
        API_SEARCH.getListDataGroup(this.state.pagination.current, this.state.pagination.pageSize, keyword, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        loading: false,
                        data: getContent(res)
                    });
                }
            }).catch(err => {
                this.setState({ loading: false });
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    handleSearch = async keyword => {
        await this.setState({
            loading: true,
            pagination: {
                ...this.state.pagination,
                current: 1
            },
            keyword
        });
        this.getInitiateSearchDataGroup(keyword);
        this.getSearchDataGroup(keyword);
    }

    handleSelectedPage = currentPage => {
        this.setState(
            {
                loading: true,
                pagination: {
                    ...this.state.pagination,
                    current: currentPage,
                },
            },
            () => {
                this.getListDataGroup();
            }
        );
    };

    handleSelectedPageSize = currentPageSize => {
        this.setState(
            {
                loading: true,
                pagination: {
                    ...this.state.pagination,
                    pageSize: currentPageSize,
                    current: 1,
                },
            },
            () => {
                this.getListDataGroup();
            }
        );
    }

    handleSorter = sorter => {
        this.setState(
            {
                loading: true,
                filter: sorter
            },
            () => {
                this.getListDataGroup();
            }
        );
    }

    handleDetailDataGroup = dataGroup => {
        this.props.history.push(`/master-data/data-group/detail/${dataGroup.id}`)
    }

    handleEditDataGroup = dataGroup => {
        this.props.history.push(`/master-data/data-group/edit/${dataGroup.id}`)
    }

    handleConfirmDeleteDataGroup = dataGroup => {
        this.setState({
            showConfirmAlert: true,
            dataGroup
        })
    }

    handleDeleteDataGroup = () => {
        this.setState({ showConfirmAlert: false })

        const data = {
            updated_at: this.state.dataGroup.updated_at
        }

        API_MASTER_DATA.deleteDataDataGroup(this.state.dataGroup.id, data, this.props.token)
            .then(res => {
                this.setState({ showSuccessAlert: true })
                setTimeout(() => {
                    this.setState({
                        showSuccessAlert: false,
                        pagination: {
                            ...this.state.pagination,
                            current: 1
                        }
                    })
                    this.getInitiateDataGroup();
                    this.getListDataGroup();
                }, 1500)
            }).catch(err => {
                this.setState({
                    errorMessage: getErrorMessage(err),
                    showErrorAlertResponse: true
                })
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    componentDidMount() {
        this._isMounted = true;

        this.getInitiateDataGroup();
        this.getListDataGroup();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    render() {
        return (
            <CheckPermissionComponent permissionConstant={[MASTER_DATA_DATA_GROUP_VIEW]} userPermission={this.props.userDetail.permissions}>
                <LoadingLoader show={this.state.loading} />
                <SearchbarMenu handleSearch={this.handleSearch} placeholder="Group ID" />
                <div className="w-full flex justify-between mb-5">
                    <div></div>
                    <CheckPermissionComponent permissionConstant={[MASTER_DATA_DATA_GROUP_INSERT]} userPermission={this.props.userDetail.permissions}>
                        <NavLink
                            to={ROUTER_CONSTANT.MASTER_DATA_DATA_GROUP_ADD}
                            className="rounded-full bg-white text-darkblue font-bold border-2 border-white px-3 py-1 flex items-center"
                            activeClassName="bg-blue-200 border-2 border-white"
                            id="btnadddatagroup"
                        >
                            <IconAddBlue />
                            <span className="ml-2">Tambah</span>
                        </NavLink>
                    </CheckPermissionComponent>
                </div>
                <div className="bg-white rounded-2xl">
                    <TableNexcare
                        column={this.state.columnsDataGroup}
                        dataTable={this.state.data}
                        pagination={this.state.pagination}
                        onPage={this.handleSelectedPage}
                        onPageSize={this.handleSelectedPageSize}
                        onSorter={this.handleSorter}
                    />
                </div>
                <Alert show={this.state.showSuccessAlert} icon="success" title="Berhasil Menghapus Data Group!" />
                <Alert show={this.state.showConfirmAlert} icon="delete" button={true} title="Apakah Anda yakin menghapus data group ini?" close={() => this.setState({ showConfirmAlert: false })} submit={() => this.handleDeleteDataGroup()} />
                <Alert show={this.state.showErrorAlertResponse} icon="warning" title={this.state.errorMessage} close={() => this.setState({ showErrorAlertResponse: false })} ok />
            </CheckPermissionComponent >
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.authentication.token,
        userDetail: state.authentication.userDetail
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleLogout: () => dispatch({ type: ActionType.IS_LOGOUT })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(DataGroup);